
export const siteNotificationIndexState = {
    namespaced: true,
    state: {
        tableOptions: {
            page: 1,
            itemsPerPage: 30,
            sortBy: ['startTime'],
            sortDesc: [true],
            mustSort: true,
            multiSort: false,
        },
    },
    mutations: {
        setTableOptions(state, tableOptions) {
            state.tableOptions = tableOptions;
        },
    },
    getters: {
        tableOptions: state => {
            return state.tableOptions;
        },
    },
};
